import { render, staticRenderFns } from "./PortalDefault.vue?vue&type=template&id=6da20b6e"
import script from "./PortalDefault.vue?vue&type=script&lang=js"
export * from "./PortalDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports